(() => {
  const tag = 'tfd-cursor-controls';
  const releaseEvent = 'tfd-cursor-controls:released';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.launcher || !this.isConnected) return;
      if (document.querySelector(tag) !== this) {
        const launcher = this.querySelector('[data-launch]');
        if (launcher) launcher.hidden = true;
        if (!this.onRelease) {
          this.onRelease = () => this.connectedCallback();
          document.addEventListener(releaseEvent, this.onRelease);
        }
        return;
      }
      this.stopWaiting();
      this.epoch = (this.epoch || 0) + 1;
      this.launcher = this.querySelector('[data-launch]');
      this.loadStatus = this.querySelector('[data-load-status]');
      if (!this.launcher) return;
      this.launcher.hidden = false;
      this.onLaunch = () => this.loadControls().then((controls) => controls?.open());
      this.launcher.addEventListener('click', this.onLaunch);
      this.onStorage = (event) => {
        if (event.key !== 'tfd.cursor.v1' || this.pending) return;
        try {
          if (JSON.parse(event.newValue)?.enabled === true) this.loadControls();
        } catch {}
      };
      window.addEventListener('storage', this.onStorage);
      try {
        if (JSON.parse(localStorage.getItem('tfd.cursor.v1'))?.enabled === true) this.loadControls();
      } catch {}
    }

    loadControls() {
      if (this.pending) return this.pending;
      const epoch = this.epoch;
      this.launcher?.setAttribute('aria-busy', 'true');
      this.pending = import(this.dataset.module).then(({ mount }) => {
        if (!this.isConnected || epoch !== this.epoch) return null;
        this.controls = mount(this);
        if (this.loadStatus) this.loadStatus.textContent = '';
        return this.controls;
      }).catch(() => {
        if (this.loadStatus) this.loadStatus.textContent = this.dataset.errorMessage || '';
        this.pending = null;
        return null;
      }).finally(() => this.launcher?.removeAttribute('aria-busy'));
      return this.pending;
    }

    stopWaiting() {
      if (!this.onRelease) return;
      document.removeEventListener(releaseEvent, this.onRelease);
      this.onRelease = null;
    }

    disconnectedCallback() {
      this.stopWaiting();
      this.epoch = (this.epoch || 0) + 1;
      this.controls?.destroy();
      this.launcher?.removeEventListener('click', this.onLaunch);
      if (this.launcher) this.launcher.hidden = true;
      window.removeEventListener('storage', this.onStorage);
      this.controls = null;
      this.pending = null;
      this.launcher = null;
      document.dispatchEvent(new Event(releaseEvent));
    }
  });
})();
